module.exports = __webpack_public_path__ + "img/app-phone-screen-png.051732a6.png";